import styled from 'styled-components'
import { rem } from 'polished'
import LineFestivalsIcon from 'LuxKit/Icons/line/LineFestivalsIcon'
import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import { useIntl } from 'react-intl'

const Wrapper = styled.div`
  margin-bottom: ${rem(12)};
`

function OfferPagePaidEntirelyWithPointsLabel() {
  const intl = useIntl()

  return (
    <Wrapper>
      <LoyaltyTierLabel
        kind="primary"
        gradient
        startIcon={<LineFestivalsIcon size="XS" />}
      >
        {intl.formatMessage({
          id: 'n_XyTbAukf7PhpyGtPnH',
          defaultMessage: 'Paid entirely with points',
        })}
      </LoyaltyTierLabel>
    </Wrapper>
  )
}

export default OfferPagePaidEntirelyWithPointsLabel
